import { Component } from '@angular/core';
import { NavController, NavParams, LoadingController, ModalController } from 'ionic-angular';
import { TPVServices } from "../../tpv/services";
import { Globals } from "../../../globals";
import { ConfigurationServices } from "../services";
import { ConfigurationCashsCreatePage } from "./configuration-cashs-create/configuration-cashs-create";
import { TranslateService } from '@ngx-translate/core';
import { AddonsTriggerVersionProPage } from '../../addons/addons-trigger-version-pro/addons-trigger-version-pro';

/**
 * Generated class for the ConfigurationCashsPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@Component({
    selector: 'page-configuration-cashs',
    templateUrl: 'configuration-cashs.html',
})
export class ConfigurationCashsPage {

    public addon_opened: boolean = false;
    cashs: any = [];

    constructor(public navCtrl: NavController,
        public navParams: NavParams,
        public tpvServices: TPVServices,
        public globals: Globals,
        public loadingCtrl: LoadingController,
        public configurationServices: ConfigurationServices,
        public translate: TranslateService,
        public modalCtrl: ModalController) {

    }

    async ionViewWillEnter() {
        this.globals.GAtrackView('Configuration', 'Configuration - Cashs - List', this.globals.restaurant.email, 'View', 'List cashs', 'Configuration', '');

        let loadingPopup = this.loadingCtrl.create({
            spinner: 'crescent',
            content: this.translate.instant('instant-cargando-cajas')
        });
        loadingPopup.present();
        this.cashs = await this.configurationServices.getAllCashs(this.globals.restaurant_uid);
        loadingPopup.dismiss();
    }

    create() {
        if (this.globals.checkLimitsByLicense('config', 'multi_cash')) {
            this.navCtrl.push(ConfigurationCashsCreatePage);
        } else {
            this.navCtrl.push(AddonsTriggerVersionProPage);
        }
    }

    editar(cash) {
        if (cash._active) {
            this.navCtrl.push(ConfigurationCashsCreatePage, {
                update_state: true,
                cash: cash,
            });
        } else {
            this.navCtrl.push(AddonsTriggerVersionProPage);
        }
    }
}


// WEBPACK FOOTER //
// ./src/pages/configuration/configuration-cashs/configuration-cashs.ts